
import { Flex, Table, Th, Tr } from 'styling/GlobalStyles'
import { Td } from 'components/Td/Td'
import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { formatDateForDisplay, formatDateWithTime, formatParams } from 'utils/helpers'
import { useState } from 'react'
import usePaginate from 'hooks/usePaginate'
import { Title } from 'components/Dashboard/Title'
import { DashboardModalArrow, DashboardModalContainer, DashboardModalContent, DashboardModalWrapper } from 'pages/Dashboard/Dashboard.styled'
import { InfoIcon } from 'assets/icons/InfoIcon'
import { INameId } from 'constants/globalTypes'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { endOfWeek, startOfWeek } from 'date-fns'

export const FuelAlertsModal = ({ closeModal }) => {
    const [params, setParams] = useState({
        dateFrom: startOfWeek(new Date(), { weekStartsOn: 1 }),
        dateTo: endOfWeek(new Date(), { weekStartsOn: 1 }),
    })
    const [list, setList] = useState<IFuelAlert[]>([])
    const [loading, setLoading] = useState(false)

    const parserFunction = (data: IFuelAlertsResponse) => {
        return data.alerts
    }

    usePaginate('fuel/management/dashboard/fuel/alert', formatParams(params), null, parserFunction, setList, null, null, null, true, null, setLoading)

    return (
        <DashboardModalWrapper>
            <DashboardModalContainer style={{ width: screen.availWidth < 500 ? '100%' : '60vw' }} >
                <Flex width='100%' gap='1rem' style={{ margin: '2rem 0' }} >
                    <DashboardModalArrow onClick={closeModal}>
                        <ArrowLeft />
                    </DashboardModalArrow>

                    <Title
                        center
                        mainIcon={<InfoIcon />}
                        height={'fit-content'}
                        title='Alerts'
                        color='#FF4F46'
                        rightSide={<Flex gap='1rem' >
                            <CalendarInput
                                maxDate={new Date(params.dateTo)}
                                labelText='Start date'
                                defaultValue={params.dateFrom}
                                onChange={v => setParams(p => ({ ...p, dateFrom: v }))}
                            />
                            <CalendarInput
                                maxDate={new Date(params.dateFrom)}
                                labelText='End date'
                                defaultValue={params.dateTo}
                                onChange={v => setParams(p => ({ ...p, dateTo: v }))}

                            />
                        </Flex>}
                    />
                </Flex>

                <DashboardModalContent width='100%' >
                    {list?.length ? <Table width='100%' height='100%' modal={true}>

                        <Th next minWidth={0}>
                            <Td w='20%' noTooltip text='Date' />
                            <Td w='20%' noTooltip text='Type' />
                            <Td w='20%' noTooltip text='Amount' />
                            <Td w='20%' noTooltip text='Machine' />
                            <Td w='20%' noTooltip text='Location' />
                        </Th>
                        {list?.map((n, i) => (
                            <Tr
                                key={i}
                                minWidth={0}

                            >
                                <Td w='20%' text={formatDateForDisplay(n.date, true)} />
                                <Td w='20%' text={n.type == 1 ? 'Addition' : 'Removal'} />
                                <Td w='20%' text={n.amount || '/'} />
                                <Td w='20%' text={n.machine?.name || '/'} />
                                <Td w='20%' text={n.location?.place || '/'} />
                            </Tr>
                        ))}
                    </Table> : <NoItems title='Alerts' />}
                </DashboardModalContent>
            </DashboardModalContainer>
        </DashboardModalWrapper>
    )
}

export interface IFuelAlertsResponse {
    alerts: IFuelAlert[]
}
export interface IFuelAlert {
    id: number
    date: string
    type: number
    amount: number
    machine: INameId
    location: {
        latitude: string
        longitude: string
        place: string
        address: string
    }
}[]
